import { render, staticRenderFns } from "./RiskPermitWorkDoc.vue?vue&type=template&id=d545c070&scoped=true&"
import script from "./RiskPermitWorkDoc.vue?vue&type=script&lang=js&"
export * from "./RiskPermitWorkDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d545c070",
  null
  
)

export default component.exports